import { TranslateLoader } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { AppConfiguration } from '../../app-configuration';

export class TranslationLoaderService implements TranslateLoader {
  private readonly controllerUrl = this.appConfiguration.serverApiUrl + '/public/translations';

  constructor(private httpClient: HttpClient,
              private appConfiguration: AppConfiguration) {
  }

  getTranslation(lang: string): Observable<any> {
    return this.httpClient.get(this.controllerUrl + `?lang=${lang}`)
      .pipe(
        map((response: any) => response)
      );
  }
}
